import createIcon from '../../createIcon';

/**
 * @component @name ThumbsUpDown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8xODE5NCkiPgo8cGF0aCBkPSJNMTIgNkMxMiA1LjQ1IDExLjU1IDUgMTEgNUg1LjgyTDYuNDggMS44Mkw2LjUgMS41OUM2LjUgMS4yOCA2LjM3IDEgNi4xNyAwLjc5TDUuMzggMEwwLjQ0IDQuOTRDMC4xNyA1LjIxIDAgNS41OSAwIDZWMTIuNUMwIDEzLjMzIDAuNjcgMTQgMS41IDE0SDguMjVDOC44NyAxNCA5LjQgMTMuNjIgOS42MyAxMy4wOUwxMS44OSA3LjhDMTEuOTYgNy42MyAxMiA3LjQ0IDEyIDcuMjVWNlpNMjIuNSAxMEgxNS43NUMxNS4xMyAxMCAxNC42IDEwLjM4IDE0LjM3IDEwLjkxTDEyLjExIDE2LjJDMTIuMDQgMTYuMzcgMTIgMTYuNTYgMTIgMTYuNzVWMThDMTIgMTguNTUgMTIuNDUgMTkgMTMgMTlIMTguMThMMTcuNTIgMjIuMThMMTcuNSAyMi40MkMxNy41IDIyLjczIDE3LjYzIDIzLjAxIDE3LjgzIDIzLjIyTDE4LjYyIDI0TDIzLjU2IDE5LjA2QzIzLjgzIDE4Ljc5IDI0IDE4LjQxIDI0IDE4VjExLjVDMjQgMTAuNjcgMjMuMzMgMTAgMjIuNSAxMFoiIGZpbGw9ImJsYWNrIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjQwMl8xODE5NCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ThumbsUpDown = createIcon('ThumbsUpDown', [
  ['g', { clipPath: 'url(#clip0_2402_18194)', key: '1or2jg' }],
  ['defs', { key: '9ahrjx' }],
]);

export default ThumbsUpDown;
